<template>
  <div class="flex flex_between">
    <md-field :class="[{ 'md-error': error }]">
      <label >{{ $t("seller.upload.Currency") }}</label>
      <TbSelect v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="options"
				options-value-field="isoCode"
				options-display-field="isoCode"
				:disabled="disabled"
				:required="required"
      />
      <span v-if="error" class="validation-error">{{ error }}</span>
    </md-field>
  </div>
</template>
<script>
import {currencyApi} from "@/common/api/currencyApi";

export default {
  props: {
    labelText: {type: String, default: "value"},
    disabled: {type: Boolean, default: false},
    error: { type: Boolean, default: "" },
    required: {type: Boolean, default: false},
    value: {type: String, default: ""},
    includeOnly: {type: Object, default: []},
	isForProspectiveUpload: {type: Boolean, default: false}
  },
  data() {
    return {
      moduleValue: "",
      options: [],
      currencyFilter: []
    };
  },
  beforeMount() {
    this.getList();
  },
  mounted() {
    this.moduleValue = this.value;
    this.currencyFilter = this.includeOnly
  },
  methods: {
    onSelect(val) {
      this.$emit("input", val);
    },
    getList() {
      currencyApi
        .ListEnabled(this.isForProspectiveUpload)
        .then((res) => {
          if (this.currencyFilter.length > 0) {
            this.options = res.filter(entry => this.currencyFilter.includes(entry.isoCode));
          } else {
            this.options = res;
          }
		  this.resetIfCurrentValueIsNotAllowed();
        })
        .catch(this.toast);
    },
	resetIfCurrentValueIsNotAllowed() {
		// Options not loaded yet. Reset is checked again when options are set.
		if (!this.options.length) {
			return;
		}

		// Current value is not an enabled currency, reset the value.
		if (this.moduleValue && !this.options.find(item => item.isoCode === this.moduleValue)) {
			this.moduleValue = null;
		}
	}
  },
  watch: {
    value() {
      this.moduleValue = this.value;
	  this.resetIfCurrentValueIsNotAllowed();
    }
  }
};
</script>
